import React from "react";

import {
  AccessTime,
  DateRange,
  TransferWithinAStation,
  Workspaces,
  Badge,
  CurrencyExchange,
  Person,
  Groups,
} from "@mui/icons-material";

export const leaveHistory = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "username",
    name: "Name",
  },
  {
    key: "department_name",
    name: "Department",
  },
  {
    key: "option",
    name: "Leave Type",
  },
  {
    key: "from_date",
    name: "From",
  },
  {
    key: "to_date",
    name: "To",
  },
  {
    key: "business_days",
    name: "Duration",
  },
  {
    key: "approver_name",
    name: "Approver",
  },
  {
    key: "status",
    name: "Status",
  },
];

export const permissionHistory = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "username",
    name: "Name",
  },
  {
    key: "department_name",
    name: "Department",
  },

  {
    key: "from_date",
    name: "Date",
  },
  {
    key: "total_time",
    name: "Duration",
  },
  {
    key: "approver_name",
    name: "Approver",
  },
  {
    key: "status",
    name: "Status",
  },
];

export const teamZoneLoanHistory = [
  { name: "Employee Name", key: "user_name" },
  { name: "Date", key: "applied_date" },
  { name: "Department", key: "department_name" },
  { name: "Loan Amount", key: "principal_amount" },
  { name: "Tenure", key: "tenure_months" },
  { name: "Interest", key: "interest_rate" },
  { name: "Total Amount", key: "monthly_installment" },
  { name: "Loan Type", key: "loan_type" },
  { name: "Interest Type", key: "interest_type" },
  { name: "Status", key: "status" },
  { name: "Action" },
];

export const overTimeHistoryHeader = [
  {
    key: "date",
    name: "Date",
  },
  {
    key: "username",
    name: "Employee name",
  },
  {
    key: "shift",
    name: "Shift Name",
  },
  {
    key: "work_hours",
    name: "Working Hours",
  },
  {
    key: "shift_time",
    name: "Shift Time",
  },
  {
    key: "overtime_start_formated",
    name: "OverTime Start",
  },
  {
    key: "overtime_end_formated",
    name: "OverTime End",
  },
  {
    key: "over_time",
    name: "Over Time",
  },
  {
    key: "approvedby",
    name: "Approver",
  },
  {
    key: "createdat",
    name: "Approved At",
  },
];

export const overTimeRejectHeader = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "date",
    name: "Date",
  },
  {
    key: "username",
    name: "Employee name",
  },
  {
    key: "shift",
    name: "Shift Name",
  },
  {
    key: "work_hours",
    name: "Working Hours",
  },
  {
    key: "shift_time",
    name: "Shift Time",
  },
  {
    key: "overtime_start_formated",
    name: "OverTime Start",
  },
  {
    key: "overtime_end_formated",
    name: "OverTime End",
  },
  {
    key: "over_time",
    name: "Over Time",
  },
  {
    key: "approvedby",
    name: "Rejected by",
  },
  {
    key: "createdat",
    name: "Rejected At",
  },
];

export const weekoffRejectHeader = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "user_name",
    name: "Employee name",
  },
  {
    key: "date",
    name: "Date",
  },

  {
    key: "shift_name",
    name: "Shift Name",
  },
  {
    name: "Approval Type",
    key: "approval_type",
  },
  {
    key: "check_in_datetime",
    name: "Check In",
  },
  {
    key: "check_out_datetime",
    name: "Check Out",
  },
  {
    key: "rejectedby",
    name: "Rejected by",
  },
  {
    key: "rejectedat",
    name: "Rejected At",
  },
];

export const incentivePendingHeader = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "incentive_name",
    name: "Incentive Name",
  },
  {
    key: "incentive_type",
    name: "Incentive Type",
  },
  {
    key: "calculation_mode",
    name: "Calculation Mode",
  },
  {
    key: "fixed_amount",
    name: "Amount",
  },
  {
    key: "eligibility_met_employees",
    name: "Eligibility Met Person",
  },
  {
    key: "Action",
    name: "Action",
  },
];

export const incentiveHistoryHeader = [
  {
    key: "incentive_name",
    name: "Incentive Name",
  },
  {
    key: "incentive_type",
    name: "Incentive Type",
  },
  {
    key: "calculation_mode",
    name: "Calculation Mode",
  },
  {
    key: "fixed_amount",
    name: "Amount",
  },
  {
    key: "eligibility_met_employees",
    name: "Eligibility Met Person",
  },
  {
    key: "status",
    name: "Status",
  },
];

export const EligibilityType = [
  {
    id: 1,
    name: "Department",
  },
  {
    id: 2,
    name: "Designation",
  },
  {
    id: 3,
    name: "Role",
  },
  {
    id: 4,
    name: "Individual",
  },
  {
    id: 4,
    name: "Payrollgroup",
  },
];

export const EligibleEmployeeHeader = [
  {
    key: "employee_id",
    name: "Employee ID",
  },
  {
    key: "employee_name",
    name: "Employee Name",
  },
  {
    key: "department",
    name: "Department",
  },
  {
    key: "designation",
    name: "Designation",
  },
  {
    key: "role",
    name: "Role",
  },
];

export const EligibleMetEmployeeHeader = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "employee_id",
    name: "Emp ID",
  },
  {
    key: "employee_name",
    name: "Name",
  },
  {
    key: "department",
    name: "Department",
  },
  {
    key: "designation",
    name: "Designation",
  },
  {
    key: "role",
    name: "Role",
  },
];

export const EligibleMetEmployeeCustomHeader = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "employee_name",
    name: "Employee Name",
  },
  {
    key: "incentive_amount",
    name: "Amount",
  },
  {
    key: "action",
    name: "Action",
  },
];

export const RemovedEmployeeHeader = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "employee_name",
    name: "Employee Name",
  },
  {
    key: "incentive_amount",
    name: "Amount",
  },
];

export const AdvanceHeader = [
  {
    key: "user_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "repayment_date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "amount",
    name: "Amount",
    type: "string",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
  },
  {
    key: "advance_type",
    name: "Advance Type",
    type: "string",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

export const myZoneLeaveHeader = [
  { name: "", key: "expand" },
  { name: "Name", key: "user_name" },
  { name: "Leave Type", key: "leave_type" },
  { name: "Start Date", key: "from_date" },
  { name: "End Date", key: "to_date" },
  { name: "Businees Days", key: "business_days" },
  { name: "Status", key: "status" },
];

export const TeamZoneLeave = [
  { name: "", key: "expand" },
  {
    key: "username",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "leave_type",
    name: "Leave Type",
    type: "string",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    key: "from_date",
    name: "Start Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "to_date",
    name: "End Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "business_days",
    name: "Business Days",
    type: "string",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
  },
  {
    key: "approver_name",
    name: "Approver",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

// Permission-only screen (a split out of the combined WorkAdjustment table,
// which only surfaced 6 generic columns). Adds the From/To time and Approver
// columns that combined table never showed, and drops the "Type" column —
// redundant once every row on this screen is a Permission request. Two
// separate start_time/end_time columns rather than one combined "window"
// display column so each stays independently filterable/sortable in
// CustomFilter, like every other entry in this file.
export const TeamZonePermission = [
  { name: "", key: "expand" },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "start_time",
    name: "Start Time",
    type: "string",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "end_time",
    name: "End Time",
    type: "string",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "applied_on",
    name: "Applied On",
    type: "date",
    icon: <DateRange fontSize="small" />,
  },
  {
    key: "approver_name",
    name: "Approver",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

// On Duty-only screen — same shape/reasoning as TeamZonePermission above,
// since On Duty rows carry the exact same fields (date/start_time/end_time/
// approver) inside the combined actual-special-attendance payload.
export const TeamZoneOnDuty = [
  { name: "", key: "expand" },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "start_time",
    name: "Start Time",
    type: "string",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "end_time",
    name: "End Time",
    type: "string",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "approver_name",
    name: "Approver",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

export const TeamZoneCompOff = [
  { name: "", key: "expand" },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "earned_date",
    name: "Earned Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "earned_date",
      toField: "earned_date",
    },
  },
  {
    key: "requested_date",
    name: "Requested Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "requested_date",
      toField: "requested_date",
    },
  },
  {
    key: "approver_name",
    name: "Approver",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

// Break/Cancel-Break-only screen. Unlike TeamZonePermission/TeamZoneOnDuty/
// TeamZoneCompOff, this table shows two attendance_type values in one list
// (Break + Cancel Break), so — unlike those three — the Type column is kept
// rather than dropped. Cancel Break rows have no break_type/break_start_time/
// break_end_time at the row's top level, so those columns render "N/A" for
// Cancel Break rows via the same generic (value[head.key] ?? "N/A") fallback
// every list screen in this series already uses.
export const TeamZoneBreak = [
  { name: "", key: "expand" },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "attendance_type",
    name: "Type",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
  {
    key: "date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "break_type",
    name: "Break Category",
    type: "autocomplete",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "break_start_time",
    name: "Start Time",
    type: "string",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "break_end_time",
    name: "End Time",
    type: "string",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "duration",
    name: "Duration",
    type: "string",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "approver_name",
    name: "Approver",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

// Advance Salary list — reads the `advance/request/` endpoint, which has
// its own row shape. For Team Workspace we show the compact business table
// layout used by the latest Advance Requests screen.
export const TeamZoneAdvanceSalary = [
  { name: "", key: "expand" },
  {
    key: "request_id",
    name: "Request ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "user_name",
    name: "Employee Name",
    type: "string",
    icon: <Person fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "advance_type",
    name: "Type",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "effective_amount",
    name: "Amount",
    type: "number",
    icon: <CurrencyExchange fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
  {
    key: "request_date",
    name: "Request Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "request_date",
      toField: "request_date",
    },
  },
];

// Off-Day Duty list — merges two backend sources (Pre-Approval + Post-
// Approval) into one table. `approval_mode` ("Planned"/"Retrospective") is
// derived client-side from which endpoint a row came from, not a real API
// field, but still rendered/filterable like any other autocomplete column.
export const TeamZoneOffDayDuty = [
  { name: "", key: "expand" },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "day_type",
    name: "Duty Type",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
  {
    key: "approval_mode",
    name: "Approval Mode",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
  {
    key: "approver_name",
    name: "Approver",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  // Previously only visible in the expand row's status timeline (already
  // server-formatted, local_tz-converted "DD-MM-YYYY, HH:mm" — see
  // Team_Zone/Approve/Day_off/views.py's applied_on) -- exposing it here
  // means the table and the CSV/Excel/PDF export both read this exact same
  // value, so there's no longer a "screen shows one time, report shows
  // another (or none)" gap.
  {
    key: "applied_on",
    name: "Applied On",
    type: "date",
    icon: <DateRange fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

// Overtime list — merges two backend sources (Pre-Approval "Planned OT" +
// Post-Approval "Completed OT") into one table. The two sources don't share
// field names for date/hours (`ot_date`/`ot_duration` vs `date`/
// `worked_hours`), so the list screen normalizes both onto `display_date`/
// `display_worked_hours`/`display_approved_hours` before rows reach this
// header. `approval_mode` ("Planned"/
// "Completed") is derived client-side, not a real API field.
export const TeamZoneOverTime = [
  { name: "", key: "expand" },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "department",
    name: "Department",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    key: "display_date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "display_date",
      toField: "display_date",
    },
  },
  {
    key: "display_worked_hours",
    name: "Worked Hrs",
    type: "string",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "display_approved_hours",
    name: "Approved Hrs",
    type: "string",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "approval_mode",
    name: "Workflow",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
  {
    key: "approver_name",
    name: "Approver",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];
